import { render, staticRenderFns } from "./RecitalActs.vue?vue&type=template&id=4c31054e&"
import script from "./RecitalActs.vue?vue&type=script&lang=js&"
export * from "./RecitalActs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports